import {useSyncExternalStore} from "react";
import {isDevMenuEnabled, subscribeDevMenu} from "../utils/dev-menu.js";

const useDevMenu = () => useSyncExternalStore(subscribeDevMenu, isDevMenuEnabled);

export default useDevMenu;
